import LocomotiveScroll from 'locomotive-scroll'
import {gsap} from 'gsap'
import {ScrollTrigger} from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

const init = (smooth) => {
  const
    locoScroll = new LocomotiveScroll({
      el: document.querySelector(".smooth-scroll"),
      smooth: smooth,
      getDirection: true,
      smoothMobile: 0,
      multiplier: 0.5,
      // lerp: 0.03,
      lerp: 0.08,
      mobile: {
        smooth: false
      },
      tablet: {
        smooth: false
      }
    }),
    percentageCheck = {
      25: false,
      50: false,
      75: false,
      100: false
    },
    percentageSend = [25, 50, 75, 100];

  // each time Locomotive Scroll updates, tell ScrollTrigger to update too (sync positioning)
  locoScroll.on("scroll", ({limit, scroll}) => {
    // const progress = scroll.y / limit.y * 100

    // //TRACKING GTM :_D
    // if (!percentageCheck[25] && progress >= 25 && progress < 50) {
    //   percentageCheck[25] = true;
    //   document.dispatchEvent(new CustomEvent('ScrollPercentage', {detail: {percentage: "25"}}));
    // }
    // if (!percentageCheck[50] && progress >= 50 && progress < 75) {
    //   percentageCheck[50] = true;
    //   document.dispatchEvent(new CustomEvent('ScrollPercentage', {detail: {percentage: "50"}}));
    // }
    // if (!percentageCheck[75] && progress >= 75 && progress < 100) {
    //   percentageCheck[75] = true;
    //   document.dispatchEvent(new CustomEvent('ScrollPercentage', {detail: {percentage: "75"}}));
    // }
    // if (!percentageCheck[100] && progress == 100) {
    //   percentageCheck[100] = true;
    //   document.dispatchEvent(new CustomEvent('ScrollPercentage', {detail: {percentage: "100"}}));
    // }
    ScrollTrigger.update
  });

  // tell ScrollTrigger to use these proxy methods for the ".smooth-scroll" element since Locomotive Scroll is hijacking things
  ScrollTrigger.scrollerProxy(".smooth-scroll", {
    scrollTop(value) {
      return arguments.length ? locoScroll.scrollTo(value, 0, 0) : locoScroll.scroll.instance.scroll.y
    }, // we don't have to define a scrollLeft because we're only scrolling vertically.
    getBoundingClientRect() {
      return {top: 0, left: 0, width: window.innerWidth, height: window.innerHeight}
    },
    // LocomotiveScroll handles things completely differently on mobile devices - it doesn't even transform the container at all! So to get the correct behavior and avoid jitters, we should pin things with position: fixed on mobile. We sense it by checking to see if there's a transform applied to the container (the LocomotiveScroll-controlled element).
    pinType: document.querySelector(".smooth-scroll").style.transform ? "transform" : "fixed"
  })

  locoScroll.on("scroll", (event) => {
    document.documentElement.setAttribute("data-direction", event.direction)
    ScrollTrigger.update()
  })

  ScrollTrigger.addEventListener("refresh", () => locoScroll.update())

  ScrollTrigger.refresh()

  document.addEventListener('blockSmoothScroll', (event) => {
    !event.detail ? locoScroll.start() : locoScroll.stop()
  })

  const scroll_stoppers = document.querySelectorAll('.StopSrollonHover')

  if (scroll_stoppers.length > 0) {
    for (const stopper of scroll_stoppers) {
      stopper.onmouseover = () => {
        locoScroll.stop();
      }

      stopper.onmouseout = () => {
        locoScroll.start();
      }
    }
  }

  document.addEventListener('smoothScrollTo', (event) => {
    locoScroll.scrollTo(event.detail.element, {
      'duration': event.detail.duration,
      'offset': event.detail.offset,
      'disableLerp': true
    })
  })

  document.addEventListener('smoothScrollUpdate', () => {
    locoScroll.update()
    ScrollTrigger.refresh()
  })
}

export {init}
